import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// 生产环境屏蔽所有 console 打印
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  ["log", "info", "warn", "debug", "error"].forEach((m) => {
    if (typeof console[m] === "function") {
      console[m] = noop;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

